/**
 * App Mode Store
 * Hanterar växling mellan Hemberedskap och Gruppberedskap
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type AppMode = 'home' | 'group';

interface AppModeState {
  mode: AppMode;
  lastHomePath: string;
  lastGroupPath: string;
  setMode: (mode: AppMode) => void;
  setLastPath: (mode: AppMode, path: string) => void;
}

export const useAppModeStore = create<AppModeState>()(
  persist(
    (set) => ({
      mode: 'home',
      lastHomePath: '/app',
      lastGroupPath: '/app/groups',
      setMode: (mode) => set({ mode }),
      setLastPath: (mode, path) => set((state) => ({
        lastHomePath: mode === 'home' ? path : state.lastHomePath,
        lastGroupPath: mode === 'group' ? path : state.lastGroupPath,
      })),
    }),
    {
      name: 'beredskapshubben-app-mode',
    }
  )
);
